import { graphql } from "babel-plugin-relay/macro";

export const QUERY = graphql`
	query landingPageScreen_Query($first: Int, $after: String, $filterByUrlParam: String!) {
		SingleLandingPageV2 {
			singleLandingPage(first: $first, after: $after, filterByUrlParam: $filterByUrlParam) {
				pageInfo {
					endCursor
					hasPreviousPage
					hasNextPage
					startCursor
				}
				edges {
					node {
						description
						image {
							id
							url
						}
						rootNodes {
							... on LearnOpportunitiesV2Connection {
								edges {
									node {
										id
										...UseNodeLogic_LimitedAuthorizationsFragment
									}
								}
							}
						}
						title
						urlParam
					}
				}
			}
		}
	}
`;
